export default __webpack_public_path__ + "static/media/HistoryDesk.4269b575.png";